import { render, staticRenderFns } from "./LeaderShipProcedure.vue?vue&type=template&id=ca10cd3c&"
import script from "./LeaderShipProcedure.vue?vue&type=script&lang=js&"
export * from "./LeaderShipProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports